import { updateLimitOrderSubmitStatus } from './../state/dex/actions'
import { LimitOrder, Signer, CancelLimitOrderRequest } from '@tokenlon/sdk'
import { useCallback } from 'react'
import { updateRefreshToken } from '~/state/application/reducer'
import { useAppDispatch } from '~/state/hooks'
import { LimitOrderItem } from './useUserLimitOrderList'
import { LimitOrderSubmitStatus } from '~/state/dex/type'
import { captureException } from '@sentry/nextjs'
import trace from '~/ga'
import { useGA } from './useGA'
import { useWeb3React } from '@web3-react/core'

export const useLimitOrderCancel = () => {
  const { account, provider, chainId } = useWeb3React()
  const { trackClick } = useGA()
  const dispatch = useAppDispatch()
  return useCallback(
    async (order: LimitOrderItem) => {
      dispatch(
        updateLimitOrderSubmitStatus(LimitOrderSubmitStatus.CancelOrderPending),
      )
      const signer = new Signer(provider, 'web')
      try {
        const sig = await signer.signCancelLimitOrder([order.orderHash])
        const cancelLimitOrderRequest: CancelLimitOrderRequest = {
          chainId,
          orderHashes: [order.orderHash],
          cancelSig: sig,
        }
        await LimitOrder.cancelLimitOrder(cancelLimitOrderRequest)
        dispatch(updateRefreshToken(+new Date()))
        dispatch(
          updateLimitOrderSubmitStatus(
            LimitOrderSubmitStatus.CancelOrderSuccess,
          ),
        )
        trackClick('webtl_lo_active_cancel', { is_success: 1 })
      } catch (error) {
        console.error(error)

        trackClick('webtl_lo_active_cancel', {
          is_success: 0,
          message: error?.message,
        })

        if (error && Number(error.code) === 4001) {
          dispatch(
            updateLimitOrderSubmitStatus(
              LimitOrderSubmitStatus.CancelOrderRejected,
            ),
          )
        } else {
          dispatch(updateRefreshToken(+new Date()))
          if (error?.isAxiosError && error?.response?.data.code) {
            const status =
              LimitOrderSubmitStatus[
                'SignOrderFailureCode' + error.response.data.code
              ] || LimitOrderSubmitStatus.CancelOrderFailure
            dispatch(updateLimitOrderSubmitStatus(status))
          } else {
            dispatch(
              updateLimitOrderSubmitStatus(
                LimitOrderSubmitStatus.CancelOrderFailure,
              ),
            )
          }
          captureException(error)
        }
      }
    },
    [account, provider, chainId],
  )
}
